import { render, staticRenderFns } from "./XeroLogo.vue?vue&type=template&id=e8261954"
import script from "./XeroLogo.vue?vue&type=script&lang=js"
export * from "./XeroLogo.vue?vue&type=script&lang=js"
import style0 from "./XeroLogo.vue?vue&type=style&index=0&id=e8261954&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports